
export default {
  name: 'ProductsIndices',
  fetchOnServer: false,

  data() {
    return {
      features: this.$t('features'),
    }
  },
}
